const initialState = {
  currentPage: "",
};
const ActivePageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CURRENT_PAGE":
      return (initialState.currentPage = action.payload);
    default:
      return state;
  }
};

export default ActivePageReducer;
